import * as commonConst from '../../common/constants';
import * as step3Const from './constants';
import * as service from './service';
import Vue from 'vue';

export default {

    [step3Const.QueryProductNetworkInterfaceQuota](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.QueryProductNetworkInterfaceQuota);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data)
            }).catch(e => {
                reject(e);
            });
        });
    },

    [step3Const.ValidateIpv6Support](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(service.ValidateIpv6Support, params);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                // ctx.commit(step3Const.ValidateIpv6Support, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step3Const.AllVpcInfo](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(service.AllVpcInfo,{params:params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step3Const.AllVpcInfo, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step3Const.AllocatedAdrList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(service.AllocatedAdrList,{params: params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step3Const.AllocatedAdrList, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step3Const.DescribePrivateIpAddressAttributes](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(service.DescribePrivateIpAddressAttributes, params);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step3Const.DescribePrivateIpAddressAttributes, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step3Const.DescribeSubnets](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(service.DescribeSubnets,{params: params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step3Const.DescribeSubnets, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step3Const.AdrList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(service.AdrList,{params: params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step3Const.AdrList, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step3Const.AdrCount](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(service.AdrCount, {
                params: params
            });
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                // resolve(data);
                if (data.msg) {
                    reject(data.msg)
                } else {
                    resolve(data);
                }
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    //获取支持IPV6的机型ProductTypeId的数据
    [step3Const.getIpv6SupportProductType](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.getIpv6SupportProductType);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [step3Const.DescribeSecurityGroupsQuota](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.DescribeSecurityGroupsQuota);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data)
            }).catch(e => {
                reject(e);
            });
        });
    },
    //--以下为未登录actions--
    [step3Const.noLoginAllVpcInfo](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(service.noLoginAllVpcInfo,{params:params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step3Const.noLoginAllVpcInfo, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step3Const.noLoginAdrList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(service.noLoginAdrList,{params: params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step3Const.noLoginAdrList, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    //--以上为未登录actions--
}
